import React from 'react';
import { ILeanShift } from '../../../BusinessJob/models';
import { IShift } from 'models';
import EditModalWithoutTimeChangeRequest from './EditModalWithoutTimeChangeRequest';
import EditModalWithTimeChangeRequest from './EditModalWithTimeChangeRequest';

export default function EditModal({
    open,
    onClose,
    shift,
    providerName,
    refresh,
    timeChangeFlagActive,
}: {
    open: boolean;
    onClose: () => void;
    shift: IShift | ILeanShift;
    providerName?: string;
    refresh: () => void;
    timeChangeFlagActive: boolean;
}) {
    if (timeChangeFlagActive && providerName) {
        return (
            <EditModalWithTimeChangeRequest
                open={open}
                onClose={onClose}
                shift={shift}
                providerName={providerName}
                refresh={refresh}
            />
        );
    } else {
        return <EditModalWithoutTimeChangeRequest open={open} onClose={onClose} shift={shift} refresh={refresh} />;
    }
}
